import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../context/AlertContext";
import { ServiciosContext } from "../../context/ServiciosContext";
import { ConfiguracionContext } from "../../context/ConfiguracionContext";
import { ThemeProvider, createMuiTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Spinner from "./Spinner";
import { AuthContext } from "../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Navigate, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import Menu from "./Menu";
import { InputNumber } from "primereact/inputnumber";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { InputMask } from "primereact/inputmask";
import IconButton from "@mui/material/IconButton";
import Facturacion from "./Facturacion";
import * as EmailValidator from "email-validator";
import { FileUpload } from "primereact/fileupload";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

export default function Comprobantes(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const [visible, setVisible] = useState(false);
  const [visibleFechas, setVisibleFechas] = useState(false);
  const [fechas, setFechas] = useState(null);
  const toast = useRef(null);
  const [comprobante, guardarComprobante] = useState(null);
  const [titularId, setTitularId] = useState(null);
  const [titularNombre, setTitularNombre] = useState(null);
  const [titularSeleccionado, setTitularSeleccionado] = useState(null);
  const [numero, setNumero] = useState(null);
  const [visibleComprobante, setVisibleComprobante] = useState(false);
  const [todosLosCobradores, setTodosLosCobradores] = useState(false);
  const [proceso, guardarProceso] = useState(null);
  const [visibleEnvios, setVisibleEnvios] = useState(false);
  const [emailAddress, guardarEmailAddress] = useState(null);
  const [celular, guardarCelular] = useState(null);
  const [periodo, guardarPeriodo] = useState(null);
  const [cobrador, guardarCobrador] = useState(null);
  const [saldo, guardarSaldo] = useState(null);
  const [formaPago, guardarFormaPago] = useState(null);
  const [emailComprobante, setEmailComprobante] = useState(false);
  const [emailLink, setEmailLink] = useState(false);
  const [whatsAppComprobante, setWhatsAppComprobante] = useState(false);
  const [whatsAppLink, setWhatsAppLink] = useState(false);
  const [linkEmailEnable, guardarLinkEmailEnable] = useState(null);
  const [linkMpEnable, guardarLinkMpEnable] = useState(null);
  const [noCobra, setNoCobra] = useState(null);
  const toastWarm = useRef(null);

  let navigate = useNavigate();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    statusAcceso2,
    statusAcceso3,
    rows,
    configuracion,
    empresas,
    verComprobante,
    comprobantes,
    empresaElegida,
    tiposFacturas,
    obtenerAcceso,
    obtenerAcceso2,
    obtenerAcceso3,
    obtenerComprobantes,
    obtenerDatosTitulares,
    setRows,
    guardarFactura,
    guardarTitular,
    guardarIdComprobante,
    guardarUrlPdf,
    setVerComprobante,
    generarLinkMp,
    imprimirComprobantes,
    procesoImpresion,
    obtenerEmpresas,
    crearComprobantePdf,
    enviarEmailComprobante,
    enviarWhatsAppComprobante,
    cambiarCobradorComprobante,
    cambiarTipoFacturaComprobante,
    eliminarComprobante,
    obtenerTiposFacturas,
    cambiarNoCobrable,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "VisualizarComprobantes",
      });
      obtenerAcceso2({
        usuarioId: state.usuario.id,
        layout: "EnviarComprobantes",
      });
      obtenerAcceso3({
        usuarioId: state.usuario.id,
        layout: "EliminarComprobantes",
      });
    }
  }, [state.id]);

  useEffect(() => {
    obtenerEmpresas();
    obtenerTiposFacturas();
  }, []);

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  const calendar = (e) => {
    setVisibleFechas(true);
  };

  const eliminarClick = (e) => {
    if (selectedRow) {
      if (
        selectedRow.cae ||
        Number(selectedRow.total) !== Number(selectedRow.saldo)
      ) {
        toast.current.show({
          severity: "info",
          summary: "Eliminar",
          detail: "Este comprobante no se puede anular.",
          life: 3000,
        });

        return;
      }

      const numero = selectedRow.numero;
      const id = selectedRow.id;

      confirmDialog({
        message: `Esta seguro de eliminar el comprobante ${numero}.`,
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        rejectLabel: "No",
        acceptLabel: "Si",
        accept: () => {
          eliminarComprobante({
            id,
          });
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        },
        //reject: () => reject(),
      });
    } else {
      toast.current.show({
        severity: "info",
        summary: "Eliminar",
        detail: "Debe seleccionar un comprobante.",
        life: 3000,
      });
    }
  };

  const exitClick = (e) => {
    navigate("/");
  };

  const onHideFechas = (e) => {
    setVisibleFechas(false);
  };

  const onHideComprobante = (e) => {
    setVisibleComprobante(false);
  };

  const editClick = (e) => {
    if (selectedRow) {
      //guardarComprobante(selectedRow);
      //navigate(`/facturacion/${selectedRow.id}/${selectedRow.id_titular}`);
      setVisibleComprobante(true);

      //setVisible(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Visualizar",
        detail: "Debe seleccionar un comprobante.",
        life: 3000,
      });
    }
  };

  const crearLinkPdf = async (rowData) => {
    if (rowData.linkPdf) {
      toast.current.show({
        severity: "info",
        summary: "Visualizar",
        detail: "El link del pdf del comprobante ya esta creado.",
        life: 3000,
      });

      window.open(rowData.linkPdf);
    }

    let facturaElectronica = empresas.find(
      (item) => item.id === empresaElegida.id,
    ).facturaElectronica;

    if (!facturaElectronica) {
      toast.current.show({
        severity: "error",
        summary: "Pdf",
        detail: "Esta empresa no puede crear links de pdf de comprobantes.",
        life: 3000,
      });
      return;
    }

    if (!rowData.cae) {
      toast.current.show({
        severity: "error",
        summary: "Pdf",
        detail: "Este comprobante no tiene cae.",
        life: 3000,
      });
      return;
    }

    const id = rowData.id;

    let formularioId = empresas.find(
      (item) => item.id === empresaElegida.id,
    ).formularioId;

    await crearComprobantePdf({
      idComprobante: id,
      idFormulario: formularioId,
    }).then((data) => {
      let elem = document.getElementById("actualizarComprobantes");
      setTimeout(() => {
        elem.click();
      }, 500);
    });

    //window.location.reload();
  };

  const linkItems = async (rowData) => {
    const linkVencido =
      rowData.linkMp &&
      rowData.fechaLimiteMp &&
      new Date(rowData.fechaLimiteMp) < new Date();

    if (linkVencido) {
      confirmDialog({
        message: `El link de Mercado Pago venció el ${formatDate(
          rowData.fechaLimiteMp,
        )}. ¿Desea actualizar el link?`,
        header: "Link vencido",
        icon: "pi pi-info-circle",
        acceptClassName: "p-button-success",
        closable: false,
        acceptLabel: "Si",
        accept: () => generarLink(rowData),
      });
      return;
    }

    if (rowData.linkMp) {
      toast.current.show({
        severity: "info",
        summary: "Visualizar",
        detail: "El link de Mercado Pago ya esta creado.",
        life: 3000,
      });

      toast.current.show({
        severity: "info",
        summary: "Link",
        detail: `${rowData.linkMp} tiene vencimiento ${formatDate(
          rowData.fechaLimiteMp,
        )}`,
        sticky: true,
      });
      return;
    }

    generarLink(rowData);
  };

  const generarLink = async (rowData) => {
    let mp = empresas.find((item) => item.id === empresaElegida.id).mp;

    if (!mp) {
      toast.current.show({
        severity: "error",
        summary: "Visualizar",
        detail: "Esta empresa no puede crear links de Mercado Pago.",
        life: 3000,
      });
      return;
    }

    const id = rowData.id;

    await generarLinkMp({
      comprobanteId: id,
      empresaId: empresaElegida.id,
    }).then((data) => {
      let elem = document.getElementById("actualizarComprobantes");
      setTimeout(() => {
        elem.click();
      }, 500);
    });

    //window.location.reload();
  };

  const cambioCobrador = async (rowData) => {
    confirmDialog({
      message: `Desea cambiar el comprobante al Nº de cobrador ${rowData.afiliados.id_cobrador1_facturacion}`,
      header: "Confirmación",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-success",
      closable: false,
      acceptLabel: "Si",
      accept: (e) =>
        accept1(rowData.afiliados.id_cobrador1_facturacion, rowData.id),
    });
  };

  const accept1 = (cobradorId, id) => {
    cambiarCobradorComprobante({
      id: id,
      cobradorId: cobradorId,
    });
    setTimeout(() => {
      aceptarFechas();
    }, 1000);
  };

  const NoCobrableContent = ({ rowData, initialValue, onAccept, onCancel }) => {
    // El estado ahora vive dentro del contenido del Toast
    const [checked, setChecked] = useState(initialValue);

    return (
      <div
        className="p-flex p-flex-column"
        style={{ flex: "1", marginLeft: "1em" }}
      >
        <div className="p-text-center">
          <i
            className="pi pi-exclamation-triangle"
            style={{ fontSize: "3rem" }}
          ></i>
          <h4>{`¿Confirma cambio No cobrable?`}</h4>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  style={{ marginLeft: "1em" }}
                  checked={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                />
              }
              label="No Cobrable"
              labelPlacement="start"
            />
          </Grid>
        </div>
        <div className="p-grid p-fluid" style={{ marginTop: "1em" }}>
          <div className="p-col-6">
            <Button
              label="Si"
              className="p-button-success"
              // Pasamos el valor del checkbox local al aceptar
              onClick={() => onAccept(rowData.id, checked)}
            />
          </div>
          <div className="p-col-6">
            <Button label="No" className="p-button-danger" onClick={onCancel} />
          </div>
        </div>
      </div>
    );
  };

  const noCobrable = async (rowData) => {
    toastWarm.current.show({
      severity: "warn",
      sticky: true,
      content: (
        <NoCobrableContent
          rowData={rowData}
          initialValue={rowData.nocobrable || false}
          onCancel={() => toastWarm.current.clear()}
          onAccept={(id, esNoCobrable) => {
            accept3(id, esNoCobrable); // Tu lógica final
            toastWarm.current.clear();
          }}
        />
      ),
    });
  };

  const accept3 = (id, esNoCobrable) => {
    cambiarNoCobrable({
      id,
      esNoCobrable,
    });
    setTimeout(() => {
      aceptarFechas();
    }, 1000);
    opcionNo();
  };

  const cambioTipoFactura = async (rowData) => {
    let tipoFactura = null;
    let index = tiposFacturas.findIndex(
      (item) => item.id === rowData.tipofacturacion,
    );

    tipoFactura = tiposFacturas[index].id;

    toastWarm.current.show({
      severity: "warn",
      sticky: true,
      content: (
        <div
          className="p-flex p-flex-column"
          style={{ flex: "1", marginLeft: "1em" }}
        >
          <div className="p-text-center">
            <i
              className="pi pi-exclamation-triangle"
              style={{ fontSize: "3rem" }}
            ></i>
            <h4>{`Confirma cambio de tipo de factura ?`}</h4>
            <Grid item xs={6} md={12}>
              <Autocomplete
                id="tipoFactura"
                fullWidth
                options={tiposFacturas ? tiposFacturas : null}
                disablePortal
                defaultValue={
                  tiposFacturas && rowData
                    ? tiposFacturas[
                        tiposFacturas.findIndex(
                          (item) => item.id === rowData.tipofacturacion,
                        )
                      ]
                    : null
                }
                getOptionLabel={(option) => option.nombre}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="Tipo de Factura"
                    size="small"
                  />
                )}
                onChange={(event, value) => {
                  if (value) {
                    tipoFactura = value.id;
                  } else {
                    tipoFactura = null;
                  }
                }}
              />

              {/*}
              <TextField
                id="tipoFactura"
                label="Tipo de Factura"
                fullWidth
                size="small"
                type="number"
                variant="standard"
                //className={classes.textField}
                //onKeyDown={handleEnter}
                //value={coseguroAbonar}
                onChange={(e) => (tipoFactura = e.target.value)}
              />
*/}
            </Grid>
          </div>
          <div className="p-grid p-fluid" style={{ marginTop: "1em" }}>
            <div className="p-col-6">
              <Button
                type="button"
                label="Si"
                className="p-button-success"
                onClick={(e) => accept2(tipoFactura, rowData.id)}
              />
            </div>
            <div className="p-col-6">
              <Button
                type="button"
                label="No"
                className="p-button-danger"
                //style={{ marginTop: "1em" }}
                onClick={opcionNo}
              />
            </div>
          </div>
        </div>
      ),
    });
  };

  const accept2 = (tipoFactura, id) => {
    if (!tipoFactura) {
      toast.current.show({
        severity: "info",
        summary: "Tipos de Factura",
        detail: "Debe seleccionar tipo de factura.",
        life: 3000,
      });
      return;
    }
    cambiarTipoFacturaComprobante({
      id,
      tipoFactura,
    });
    setTimeout(() => {
      aceptarFechas();
    }, 1000);
    opcionNo();
  };

  function opcionNo() {
    toastWarm.current.clear();
  }

  const crearPdf = async (rowData, formularioId) => {
    guardarProceso({
      /*
      nombre:
        rowData.id_titular +
        rowData.comprobante +
        String(rowData.numero).padStart(8, "0"),
      */
      abreviatura: rowData.comprobante,
      desde: rowData.numero,
      hasta: rowData.numero,
      id_tipoComprobante: rowData.id_comprobanteafip,
      hideMessage: true,
      formularioId,
      puntoventa: rowData.puntoventa,
    });
    setTodosLosCobradores(true);
    setTimeout(() => {
      let elem = document.getElementById("callProceso");
      elem.click();
    }, 500);
  };

  const procesoPdf = async () => {
    await procesoImpresion({
      proceso,
      todosLosCobradores,
      empresaElegida,
      usuario: state.usuario.usuario,
    }).then((data) => {
      let elem = document.getElementById("imprimirFacturas");
      elem.click();
    });

    //window.location.reload();
  };

  const enviar = async (rowData) => {
    let facturaElectronica = empresas.find(
      (item) => item.id === empresaElegida.id,
    ).facturaElectronica;

    if (!facturaElectronica) {
      toast.current.show({
        severity: "error",
        summary: "Visualizar",
        detail:
          "Esta empresa no puede enviar links de comprobantes ni de Mercado Pago.",
        life: 3000,
      });
      return;
    }

    let emailsAddress = "";
    if (
      rowData.afiliados &&
      rowData.afiliados.email &&
      rowData.afiliados.email.length > 3
    ) {
      emailsAddress = rowData.afiliados.email;
    }
    if (
      rowData.afiliados &&
      rowData.afiliados.email2 &&
      rowData.afiliados.email2.length > 3
    ) {
      emailsAddress = emailsAddress + ";" + rowData.afiliados.email2;
    }
    if (
      rowData.afiliados &&
      rowData.afiliados.email3 &&
      rowData.afiliados.email3.length > 3
    ) {
      emailsAddress = emailsAddress + ";" + rowData.afiliados.email3;
    }
    if (
      rowData.afiliados &&
      rowData.afiliados.email4 &&
      rowData.afiliados.email4.length > 3
    ) {
      emailsAddress = emailsAddress + ";" + rowData.afiliados.email4;
    }
    if (
      rowData.afiliados &&
      rowData.afiliados.email5 &&
      rowData.afiliados.email5.length > 3
    ) {
      emailsAddress = emailsAddress + ";" + rowData.afiliados.email5;
    }

    emailsAddress = emailsAddress.trim();
    guardarEmailAddress(emailsAddress);

    let celularAfiliado = "";
    if (rowData.afiliados && rowData.afiliados.celular) {
      celularAfiliado = rowData.afiliados.celular.trim();
    }
    guardarCelular(celularAfiliado);

    if (rowData.periodo) {
      guardarPeriodo(rowData.periodo);
    }

    if (rowData.id_cobrador) {
      guardarCobrador(rowData.id_cobrador);
    }

    if (rowData.saldo) {
      guardarSaldo(rowData.saldo);
    }

    if (rowData.afiliados && rowData.afiliados.id_formapago) {
      guardarFormaPago(rowData.afiliados.id_formapago);
    }

    if (rowData.linkPdf) {
      guardarLinkEmailEnable(rowData.linkPdf);
    } else {
      guardarLinkEmailEnable(null);
    }
    if (rowData.linkMp) {
      guardarLinkMpEnable(rowData.linkMp);
    } else {
      guardarLinkMpEnable(null);
    }

    setEmailComprobante(false)
    setWhatsAppComprobante(false)
    setVisibleEnvios(true);
  };

  const aceptarFechas = async (exportType) => {
    //e.preventDefault();
    //Validar

    let fdesde = null;
    let fhasta = null;

    if (numero !== null && numero === 0) {
      mensajeAlerta("Comprobantes", "Número no puede ser cero !.", "error");
      return;
    }

    if ((numero === null || numero === "") && titularSeleccionado === null) {
      if (
        !fechas ||
        fechas.desde === undefined ||
        fechas.desde === null ||
        fechas.desde.trim() === ""
      ) {
        mensajeAlerta("Comprobantes", "Fecha desde es necesaria !.", "error");
        return;
      }
      if (
        !fechas ||
        fechas.hasta === undefined ||
        fechas.hasta === null ||
        fechas.hasta.trim() === ""
      ) {
        mensajeAlerta("Comprobantes", "Fecha hasta es necesaria !.", "error");
        return;
      }
      fdesde = fechas.desde + "T00:00";
      fhasta = fechas.hasta + "T23:59";
    }

    await obtenerComprobantes({
      fdesde: fdesde,
      fhasta: fhasta,
      titularSeleccionado,
      numero,
      empresaElegida,
    });
    guardarIdComprobante(null);
    onHideFechas();
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Comprobantes",
      "No tiene permiso para acceder a esta pantalla !.",
      "error",
    );
    exitClick();
    return;
  };

  const renderHeaderFechas = () => {
    return (
      <div>
        <Tag value="Comprobantes de Ventas"></Tag>
      </div>
    );
  };

  const renderFooterFechas = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarFechas}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHideFechas}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const buscarAfiliados = () => {
    if (titularNombre !== null && titularNombre !== "") {
      obtenerDatosTitulares({
        opcion: "Apellido y nombre",
        texto: titularNombre,
        empresaId: empresaElegida.id,
      });
    }
    if (titularId !== null && titularId !== "") {
      obtenerDatosTitulares({
        opcion: "Número de socio",
        texto: titularId,
        empresaId: empresaElegida.id,
      });
    }
  };

  const header = (
    <Fragment>
      <div className="p-d-flex export-buttons">
        <span
          style={{ marginLeft: "1em", marginRight: "1em" }}
          className="p-input-icon-left"
        >
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar"
          />
        </span>
        <Tag value="Comprobantes de Ventas"></Tag>
      </div>
    </Fragment>
  );

  function formatDate(dateString) {
    var allDate = dateString.replace("T", " ");
    allDate = allDate.replace(".", " ");
    allDate = allDate.split(" ");
    var thisDate = allDate[0].split("-");
    var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");
    return newDate;
  }

  const fechaTemplate = (rowData) => {
    return <Fragment>{formatDate(rowData.fecha)}</Fragment>;
  };

  const anuladoTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox checked={rowData.anulado}></Checkbox>
      </Fragment>
    );
  };

  const linkMpTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox
          checked={rowData.linkMp !== null && rowData.linkMp.length > 0}
        ></Checkbox>
      </Fragment>
    );
  };

  const linkPdfTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox
          checked={rowData.linkPdf !== null && rowData.linkPdf.length > 0}
        ></Checkbox>
      </Fragment>
    );
  };

  const vencimientoLinkTemplate = (rowData) => {
    if (rowData.fechaLimiteMp) {
      return <Fragment>{formatDate(rowData.fechaLimiteMp)}</Fragment>;
    }
  };

  const opcionesTemplate = (rowData) => {
    let empresa = empresas.find((item) => item.id === empresaElegida.id);

    return (
      <div
        style={{ display: "flex", flexWrap: "nowrap", alignItems: "center" }}
      >
        <Button
          icon="pi pi-link"
          rounded
          text
          severity={rowData.linkMp ? "danger" : "secondary"}
          onClick={(e) => linkItems(rowData)}
          aria-label="Bookmark"
          tooltip="Link M.P."
          tooltipOptions={{ position: "bottom" }}
        />
        <Button
          style={{ marginLeft: "0.2vw" }}
          icon="pi pi-file-pdf"
          rounded
          text
          severity={rowData.linkPdf ? "danger" : "secondary"}
          onClick={(e) => {
            crearLinkPdf(rowData);
          }}
          aria-label="Bookmark"
          tooltip="Link Pdf"
          tooltipOptions={{ position: "bottom" }}
        />
        <Button
          style={{ marginLeft: "0.2vw" }}
          icon="pi pi-send"
          rounded
          text
          severity="success"
          onClick={(e) => enviar(rowData)}
          aria-label="Bookmark"
          tooltip="Enviar"
          disabled={statusAcceso2 !== 200}
          tooltipOptions={{ position: "bottom" }}
        />
        {empresa.facturaElectronica ? (
          <Fragment>
            <Button
              style={{ marginLeft: "0.2vw" }}
              icon="pi pi-print"
              rounded
              text
              severity="primary"
              onClick={(e) => {
                crearPdf(
                  rowData,
                  configuracion && configuracion.destinatario === 2 ? 1 : 3,
                );
              }}
              aria-label="Bookmark"
              tooltip="Imprimir"
              tooltipOptions={{ position: "bottom" }}
            />
            {/*
            <Button
              style={{ marginLeft: "0.2vw" }}
              icon="pi pi-ticket"
              rounded
              text
              severity="primary"
              onClick={(e) => {
                crearPdf(rowData, 1);
              }}
              aria-label="Bookmark"
              tooltip="Imprimir Cupones"
              tooltipOptions={{ position: "bottom" }}
            />
            */}
          </Fragment>
        ) : (
          <Button
            style={{ marginLeft: "0.2vw" }}
            icon="pi pi-ticket"
            rounded
            text
            severity="primary"
            onClick={(e) => {
              crearPdf(rowData, 2);
            }}
            aria-label="Bookmark"
            tooltip="Imprimir Cupones"
            tooltipOptions={{ position: "bottom" }}
          />
        )}
        <Button
          style={{ marginLeft: "0.2vw" }}
          icon="pi pi-user"
          rounded
          text
          severity="warning"
          onClick={(e) => cambioCobrador(rowData)}
          aria-label="Bookmark"
          tooltip="Cambio Cobrador"
          tooltipOptions={{ position: "bottom" }}
          disabled={
            rowData &&
            rowData.afiliados &&
            rowData.id_cobrador === rowData.afiliados.id_cobrador1_facturacion
          }
        />
        <Button
          style={{ marginLeft: "0.2vw" }}
          icon="pi pi-clipboard"
          rounded
          text
          severity="danger"
          onClick={(e) => cambioTipoFactura(rowData)}
          aria-label="Bookmark"
          tooltip="Cambio tipo Factura"
          tooltipOptions={{ position: "bottom" }}
        />
        <Button
          style={{ marginLeft: "0.2vw" }}
          icon="pi pi-ban"
          rounded
          text
          severity="success"
          onClick={(e) => noCobrable(rowData)}
          aria-label="Bookmark"
          tooltip="Cambio Cobrable"
          tooltipOptions={{ position: "bottom" }}
        />
        {/*
        <Button
          style={{ marginLeft: "0.2vw" }}
          icon="pi pi-file-pdf"
          rounded
          text
          severity="danger"
          onClick={(e) => {
            const id = rowData.id;
            //obtenerItemsRendicion({ id });
            toast.current.show({
              severity: "info",
              summary: "Rendiciones",
              detail: "Obteniendo información... !",
              life: 3000,
            });
            var elem;
            elem = document.getElementById("imprimirClick");
            setTimeout(() => {
              if (elem) {
                elem.click();
              }
            }, 2000);
          }}
          aria-label="Bookmark"
          tooltip="Pdf"
          tooltipOptions={{ position: "bottom" }}
        />
        */}
        <Button
          id="actualizarComprobantes"
          icon="pi pi-print"
          tooltip="Imprimir"
          className="p-button-rounded p-button-help"
          style={{ marginLeft: "1em", display: "none" }}
          onClick={(e) => {
            let fdesde = null;
            let fhasta = null;
            if (fechas) {
              fdesde = fechas.desde + "T00:00";
              fhasta = fechas.hasta + "T23:59";
            }
            obtenerComprobantes({
              fdesde: fdesde,
              fhasta: fhasta,
              titularSeleccionado,
              numero,
              empresaElegida,
            });
            guardarIdComprobante(null);
          }}
        />
        <Button
          id="imprimirFacturas"
          icon="pi pi-print"
          tooltip="Imprimir"
          className="p-button-rounded p-button-help"
          style={{ marginLeft: "1em", display: "none" }}
          onClick={(e) => imprimirComprobantes(proceso)}
        />
        <Button
          id="callProceso"
          icon="pi pi-print"
          tooltip="Imprimir"
          className="p-button-rounded p-button-help"
          style={{ marginLeft: "1em", display: "none" }}
          onClick={(e) => procesoPdf()}
        />
      </div>
    );
  };

  const renderHeaderEnvios = () => {
    return (
      <div>
        <Tag value="Envío de links de comprobantes y Mercado Pago"></Tag>
      </div>
    );
  };

  const renderFooterEnvios = () => {
    return (
      <div>
        <ButtonMui
          onClick={(e) => aceptarEnvios(e)}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Enviar
        </ButtonMui>
        <ButtonMui
          onClick={(e) => exitEnvios()}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Salir
        </ButtonMui>
      </div>
    );
  };

  const aceptarEnvios = (e) => {
    e.preventDefault();
    if (
      emailComprobante &&
      (!emailAddress || emailAddress.trim() === "" )
    ) {
      mensajeAlerta("Comprobantes", "El email es incorrecto !.", "error");
      return;
    }

    if (
      emailComprobante &&
      emailAddress &&
      !EmailValidator.validate(emailAddress)
    ) {
      mensajeAlerta("Comprobantes", "El email no es válido !.", "error");
      return;
    }

    if (
      whatsAppComprobante &&
      (celular === null || celular === "" || celular.trim().length !== 10)
    ) {
      mensajeAlerta("Comprobantes", "El celular es incorrecto !.", "error");
      return;
    }

    if (emailComprobante) {
      enviarEmailComprobante({
        emailAddress,
        linkEmailEnable,
        linkMpEnable,
        periodo,
        empresaId: empresaElegida.id,
        cobradorId: cobrador,
        formaPagoId: formaPago,
        tipoEnvio: "fa",
        nombre: null,
        saldo: saldo,
      });
    }

    if (whatsAppComprobante) {
      enviarWhatsAppComprobante({
        celular,
        linkEmailEnable,
        linkMpEnable,
        periodo,
        empresaId: empresaElegida.id,
        cobradorId: cobrador,
        formaPagoId: formaPago,
        tipoEnvio: "fa",
        nombre: null,
        saldo: saldo,
      });
    }

    setVisibleEnvios(false);
  };

  const exitEnvios = (e) => {
    setVisibleEnvios(false);
  };

  // INICIO

  if (!verComprobante && visibleComprobante) {
    setVerComprobante(true);
    onHideComprobante();
  }

  // FIN

  //console.log(noCobra);
  //console.log(comprobante)

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      <ConfirmDialog />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Toast ref={toastWarm} position="top-center" />
          {comprobantes ? (
            <Fragment>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                style={{ align: "center", margin: "1em" }}
              >
                <Button
                  icon="pi pi-calendar"
                  tooltip="Fechas"
                  className="p-button-rounded p-button-success"
                  style={{ marginLeft: "1em" }}
                  onClick={(e) => calendar()}
                />

                <Button
                  icon="pi pi-book"
                  tooltip="Visualizar"
                  className="p-button-rounded p-button-secondary"
                  style={{ marginLeft: "1em" }}
                  onClick={editClick}
                />
                <Button
                  icon="pi pi-times"
                  tooltip="Cerrar"
                  className="p-button-rounded p-button-primary"
                  style={{ marginLeft: "1em" }}
                  onClick={exitClick}
                />
                <Button
                  icon="pi pi-trash"
                  tooltip="Eliminar"
                  className="p-button-rounded p-button-danger"
                  disabled={statusAcceso3 !== 200}
                  style={{ marginLeft: "1em" }}
                  onClick={eliminarClick}
                />

                <div className="datatable-responsive-demo">
                  <div className="card">
                    <Tooltip
                      target=".export-buttons>button"
                      position="bottom"
                    />
                    <DataTable
                      value={comprobantes}
                      selection={selectedRow}
                      onSelectionChange={(e) => {
                        setSelectedRow(e.value);
                        guardarFactura(null);
                        guardarTitular(null);
                        guardarIdComprobante(null);
                        guardarUrlPdf(null);
                      }}
                      selectionMode="single"
                      dataKey="id"
                      header={header}
                      className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                      style={{
                        fontSize: "small",
                        marginTop: "1vw",
                        fontWeight: "bold",
                      }}
                      globalFilter={globalFilter}
                      emptyMessage="No hay datos."
                      paginator
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                      rows={50}
                      rowsPerPageOptions={[10, 20, 50, 100, 500]}
                      //paginatorLeft={paginatorLeft}
                      //paginatorRight={paginatorRight}
                    >
                      <Column
                        field="id"
                        header="ID"
                        className="xxsmalldata"
                        //body={idTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="fecha"
                        header="Fecha"
                        body={fechaTemplate}
                        sortable
                        className="xxsmalldata"
                      ></Column>
                      <Column
                        field="comprobante"
                        header="Comp."
                        //body={descripcionTemplate}
                        sortable
                        className="xxsmalldata"
                      ></Column>
                      <Column
                        field="puntoventa"
                        header="P. Venta"
                        //body={descripcionTemplate}
                        sortable
                        className="xxsmalldata"
                      ></Column>
                      <Column
                        field="numero"
                        header="Número"
                        //body={descripcionTemplate}
                        sortable
                        className="xxsmalldata"
                      ></Column>
                      <Column
                        field="total"
                        header="Total"
                        //body={descripcionTemplate}
                        sortable
                        className="xxsmalldata"
                      ></Column>
                      <Column
                        field="saldo"
                        header="Saldo"
                        //body={descripcionTemplate}
                        sortable
                        className="xxsmalldata"
                      ></Column>
                      <Column
                        field="id_titular"
                        header="Nº Titular"
                        //body={descripcionTemplate}
                        sortable
                        className="xxsmalldata"
                      ></Column>
                      <Column
                        field="nombre_titular"
                        header="Nombre Titular"
                        //body={descripcionTemplate}
                        sortable
                        className="xxsmalldata"
                      ></Column>
                      <Column
                        field="id_cobrador"
                        header="Nº Cobrador"
                        //body={descripcionTemplate}
                        sortable
                        className="xxsmalldata"
                      ></Column>
                      <Column
                        field="anulado"
                        header="Anulado"
                        body={anuladoTemplate}
                        sortable
                        className="xxsmalldata"
                      ></Column>
                      <Column
                        field="tipofacturacion"
                        header="Tipo Factura"
                        //body={anuladoTemplate}
                        sortable
                        className="xxsmalldata"
                      ></Column>
                      <Column
                        field="linkMp"
                        header="Link M.P."
                        body={linkMpTemplate}
                        //sortable
                        className="xxsmalldata"
                      ></Column>
                      <Column
                        field="fechaLimiteMp"
                        header="Venc. link M.P."
                        body={vencimientoLinkTemplate}
                        //sortable
                        className="xxsmalldata"
                      ></Column>
                      <Column
                        field="linkPdf"
                        header="Link Pdf"
                        body={linkPdfTemplate}
                        //sortable
                        className="xxsmalldata"
                      ></Column>
                      <Column
                        header="Opciones"
                        className="xxsmalldata"
                        style={{ minWidth: "21rem" }}
                        body={opcionesTemplate}
                        //body={descripcionTemplate}
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </Grid>
            </Fragment>
          ) : null}

          <Dialog
            header={renderHeaderFechas()}
            visible={visibleFechas}
            closable={false}
            footer={renderFooterFechas()}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "70vw", paddingBottom: "0" }}
            position="top"
          >
            <Grid container spacing={3} style={{ marginTop: "1vw" }}>
              <Grid item xs={12} md={3}>
                <TextField
                  id="desde"
                  label="Desde"
                  type="date"
                  fullWidth
                  //onKeyDown={handleEnter}
                  value={fechas && fechas.desde ? fechas.desde : null}
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setFechas({
                      ...fechas,
                      desde: e.target.value,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="hasta"
                  label="Hasta"
                  type="date"
                  fullWidth
                  //onKeyDown={handleEnter}
                  value={fechas && fechas.hasta ? fechas.hasta : null}
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setFechas({
                      ...fechas,
                      hasta: e.target.value,
                    });
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                style={{ paddingLeft: 0, marginTop: "0em" }}
              />

              <Grid item xs={12} md={2}>
                <TextField
                  id="titular"
                  label="ID Titular"
                  fullWidth
                  type="number"
                  value={titularId ? titularId : ""}
                  disabled={titularNombre !== null && titularNombre !== ""}
                  //onKeyDown={handleEnter}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setTitularId(e.target.value);
                    setTitularSeleccionado(null);
                    setRows(null);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  id="razonSearch"
                  label="Apellido y Nombre o Razón Social"
                  fullWidth
                  value={titularNombre ? titularNombre : ""}
                  disabled={
                    titularId !== null && titularId !== "" && titularId !== 0
                  }
                  //onKeyDown={handleEnter}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setTitularNombre(e.target.value);
                    setTitularSeleccionado(null);
                    setRows(null);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={1}>
                <Button
                  icon="pi pi-search"
                  className="p-button-rounded p-button-success"
                  onClick={() => buscarAfiliados()}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <Autocomplete
                  id="razon"
                  fullWidth
                  options={rows}
                  disabled={!rows}
                  noOptionsText={"No hay opciones"}
                  style={{ marginLeft: ".8vw", color: "green" }}
                  //defaultValue={grupo ? agrupar[grupo - 1] : null}
                  value={titularSeleccionado}
                  disablePortal
                  getOptionLabel={(option) => option.nombre_razonsocial}
                  renderInput={(params) => (
                    <TextField {...params} label="Seleccione el Afiliado" />
                  )}
                  onChange={(event, value) => {
                    if (value) {
                      setTitularSeleccionado(value);
                      setTitularId(value.id_titular);
                      setTitularNombre(null);
                    } else {
                      setTitularSeleccionado(null);
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  id="numero"
                  label="Número"
                  type="number"
                  fullWidth
                  //onKeyDown={handleEnter}
                  value={numero ? numero : ""}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setNumero(e.target.value);
                  }}
                />
              </Grid>

              {/*   
              <Grid
                item
                xs={12}
                md={12}
                style={{ paddingLeft: 0, marginTop: "0em" }}
              >
                {!rows &&
                ((titularId && titularId.length >= 4) ||
                  (titularNombre && titularNombre.length >= 3)) ? (
                  <ProgressBar
                    mode="indeterminate"
                    style={{ height: "6px" }}
                  ></ProgressBar>
                ) : null}
              </Grid>
                  */}
            </Grid>
          </Dialog>

          <Dialog
            //header={renderHeader()}
            visible={visibleComprobante}
            closable={true}
            maximizable={true}
            maximized={true}
            onHide={() => onHideComprobante()}
            //footer={renderFooter()}
            breakpoints={{ "960px": "95vw" }}
            style={{ width: "95vw", paddingBottom: "0" }}
            position="center"
          >
            <Grid container spacing={3} style={{ marginTop: "0vw" }}>
              {selectedRow ? (
                <Facturacion
                  idProps={selectedRow.id}
                  titularIdProps={selectedRow.id_titular}
                />
              ) : null}
            </Grid>
          </Dialog>

          <Dialog
            header={renderHeaderEnvios()}
            visible={visibleEnvios}
            closable={false}
            footer={renderFooterEnvios()}
            breakpoints={{ "560px": "75vw" }}
            style={{ width: "70vw", paddingBottom: "0" }}
            position="top"
          >
            <Grid container spacing={3} style={{ margin: "1vw" }}>
              <Grid item xs={12} md={7} style={{ padding: "0.2vw" }} />

              <Grid item xs={12} md={7} style={{ padding: "0.2vw" }}>
                <TextField
                  value={emailAddress ? emailAddress : null}
                  variant="standard"
                  id="email"
                  label="Email"
                  fullWidth
                  onChange={(e) => {
                    if (e.target.value) {
                      guardarEmailAddress(e.target.value);
                    } else {
                      guardarEmailAddress(null);
                      setEmailComprobante(false);
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    style: { color: "red" },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={4} style={{ padding: "0.2vw" }}>
                <TextField
                  value={celular ? celular : null}
                  variant="standard"
                  id="celular"
                  label="Celular"
                  fullWidth
                  onChange={(e) => {
                    if (e.target.value) {
                      guardarCelular(e.target.value);
                    } else {
                      guardarCelular(null);
                      setWhatsAppComprobante(false);
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    style: { color: "red" },
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                style={{
                  paddingLeft: 0,
                  paddingTop: "1vw",
                }}
              >
                <FormControlLabel
                  value="yes"
                  control={
                    <Checkbox
                      color="primary"
                      checked={emailComprobante ? emailComprobante : null}
                      style={{ marginLeft: "1vw" }}
                      disabled={!emailAddress}
                      onChange={(e) => setEmailComprobante(e.target.checked)}
                    />
                  }
                  label="Email"
                  labelPlacement="start"
                  style={{ paddingLeft: ".7vw" }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                style={{
                  paddingLeft: 0,
                  paddingTop: "1vw",
                }}
              >
                <FormControlLabel
                  value="yes"
                  control={
                    <Checkbox
                      color="primary"
                      checked={whatsAppComprobante ? whatsAppComprobante : null}
                      style={{ marginLeft: "1vw" }}
                      disabled={!celular}
                      onChange={(e) => setWhatsAppComprobante(e.target.checked)}
                    />
                  }
                  label="WhatsApp"
                  labelPlacement="start"
                  style={{ paddingLeft: ".7vw" }}
                />
              </Grid>
            </Grid>
          </Dialog>
        </Fragment>
      ) : null}
      <Grid item xs={12} sm={12}></Grid>
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
